import React from 'react';
import { Component } from "puzzle";

type PROPS = {
  stringToCount: string
  maxCharacters: number
};

class LimitedLetterCounter extends Component<PROPS, {}> {

  static defaultProps = {
    className: '',
    stringToCount: '',
    maxCharacters: 150
  };

  render() {
    const { className, stringToCount, maxCharacters } = this.props;

    return (
      <span className={`k-text-right ${className}`}> {stringToCount.length}/{maxCharacters} </span>
    );
  }
}

export default LimitedLetterCounter;
